import { useContext, createContext } from 'react'

export const PersonSheetContext = createContext()

export const usePersonSheet = () => {
  return useContext(PersonSheetContext)
}

export default usePersonSheet
